import { MarketingFooter } from "./MarketingFooter";
import { MarketingHeader } from "./MarketingHeader";
import { FaqSection } from "./sections/FaqSection";
import { FeaturesSection } from "./sections/FeaturesSection";
import { FinalCtaSection } from "./sections/FinalCtaSection";
import { HeroSection } from "./sections/HeroSection";
import { HowItWorksSection } from "./sections/HowItWorksSection";
import { ProblemSolutionSection } from "./sections/ProblemSolutionSection";

/**
 * Public marketing homepage. Sticky glass nav, a motion-oriented set of sections
 * built from `homepage-copy.md`, and a footer. Sections animate on scroll via the
 * shared Framer Motion vocabulary in `@/shared/components/motion` (design.md §12).
 */
export function MarketingHome() {
  return (
    <>
      <MarketingHeader />
      {/* Clip horizontal overflow from decorative transforms (scattered/tilted
          cards in sections below the fold) so they can't widen the page on
          mobile. `clip` (not `hidden`) avoids creating a scroll container, so the
          Features section's sticky heading still works. */}
      <main className="overflow-x-clip">
        <HeroSection />
        <ProblemSolutionSection />
        <FeaturesSection />
        <HowItWorksSection />
        <FaqSection />
        <FinalCtaSection />
      </main>
      <MarketingFooter />
    </>
  );
}
